import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import 'core-js/proposals/string-replace-all-stage-4';
import { applyPolyfills, getMSSFE } from '@monorepo/utils';
import { DATA_DOG_SERVICES, datadogRumInit } from '@monorepo/utils/src/datadog';
import Router from '@pc/Router';
import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

applyPolyfills();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 60 * 1_000,
      gcTime: 300 * 1_000,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    },
  },
});

let rootElement = document.getElementById('commonLayoutContents');

if (!rootElement) {
  rootElement = document.createElement('div');
  rootElement.id = 'commonLayoutContents';
  document.body.append(rootElement);
}

datadogRumInit({
  service: DATA_DOG_SERVICES.GIFT,
  version: import.meta.env.VITE_APP_VERSION,
  applicationId: import.meta.env.VITE_APP_DD_APPLICATION_ID,
  clientToken: import.meta.env.VITE_APP_DD_CLIENT_TOKEN,
  isELT: getMSSFE('isHeavyGroup') === true,
});

ReactDOM.createRoot(document.getElementById('commonLayoutContents') as HTMLElement).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/gift">
        <QueryParamProvider adapter={ReactRouter6Adapter}>
          <QueryClientProvider client={queryClient}>
            <Router />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </QueryParamProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
